//Configurações do Saga relacinadas a esté modulo de authenticação
import { all, takeLatest } from 'redux-saga/effects';

function checkAuthenticated() {
  // console.log('Verificar Autheticação do Usuário');
}

export default all([
  takeLatest('ADD_USER_AUTHENTICATED', checkAuthenticated )
]);